import { render, staticRenderFns } from "./roleGrantForm.vue?vue&type=template&id=4657369c&scoped=true&"
import script from "./roleGrantForm.vue?vue&type=script&lang=js&"
export * from "./roleGrantForm.vue?vue&type=script&lang=js&"
import style0 from "./roleGrantForm.vue?vue&type=style&index=0&id=4657369c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657369c",
  null
  
)

export default component.exports